import {BreadcrumbType, DataStatus} from 'platform/components';

import {isNilOrEmpty} from 'ramda-adjunct';

import {useListCampaignsQuery} from '@dms/api/sales';
import {i18n} from '@dms/i18n';
import {settingsRoutes, testIds} from '@dms/routes';
import {SettingsTemplate} from '@dms/settings/shared';

import {useNavigate} from 'shared/web';

import {CampaignList} from './components/CampaignList';

export function Campaigns() {
  const navigate = useNavigate();

  const {data: campaigns, isLoading, isError} = useListCampaignsQuery();

  const handleAdd = () => navigate(settingsRoutes.campaignsNew);

  const hasNoCampaigns = isNilOrEmpty(campaigns);

  const breadcrumbs: BreadcrumbType[] = [
    {
      label: i18n.t('page.salesSettings.title'),
    },
  ];

  return (
    <SettingsTemplate
      header={{
        title: i18n.t('entity.salesCampaign.labels.title'),
        breadcrumbs,
        actions: [
          {
            type: 'button',
            title: i18n.t('entity.salesCampaign.actions.addCampaign'),
            onClick: handleAdd,
            'data-testid': testIds.settings.campaigns('addCampaignButton'),
          },
        ],
      }}
      description={i18n.t('entity.salesCampaign.labels.description')}
      data-testid={testIds.settings.campaigns('page')}
      isLoading={isLoading}
      isError={isError}
    >
      <DataStatus
        isEmpty={hasNoCampaigns}
        emptyMessage={i18n.t('entity.salesCampaign.labels.emptyTitle')}
        data-testid={testIds.settings.campaigns('emptyState')}
      >
        <CampaignList
          campaigns={campaigns ?? []}
          data-testid={testIds.settings.campaigns('list')}
        />
      </DataStatus>
    </SettingsTemplate>
  );
}
